import { useQuery } from 'react-query';

import {
  SettingsResponse,
  USER_ACCOUNT_SETTINGS_KEY,
  getUserSetting,
} from '@utils/backend-api/settings';

export default function useUserSettings() {
  const { data, isLoading: isLoadingUserSettings } = useQuery<SettingsResponse>(
    [USER_ACCOUNT_SETTINGS_KEY],
    () => getUserSetting()
  );

  return { userSettings: data, isLoadingUserSettings };
}
